import {
    Spinner,
    Modal as NextUIModal,
    ModalContent,
    ModalBody
} from '@/components/nextui'

interface InscriptionLoadingModalProps {
    isOpen: boolean
}

export const InscriptionLoadingModal = ({
    isOpen
}: InscriptionLoadingModalProps): JSX.Element => {
    return (
        <NextUIModal
            isOpen={isOpen}
            hideCloseButton
            isDismissable={false}
            isKeyboardDismissDisabled
            backdrop="opaque"
            placement="center"
        >
            <ModalContent>
                <ModalBody className="flex flex-col items-center justify-center gap-4 py-12">
                    <Spinner
                        size="lg"
                        color="primary"
                        label="Cargando Información..."
                    />
                </ModalBody>
            </ModalContent>
        </NextUIModal>
    )
}
